import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsScrutinizerciComponent } from './simple-icons-scrutinizerci.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsScrutinizerciComponent ],
    exports:      [ SimpleIconsScrutinizerciComponent ],
    bootstrap:    []
})
export class SimpleIconsScrutinizerciModule {}
